import { DATA } from '@lib/i18n';
import { ActionTree } from 'vuex';
import { IState } from './state';
import { IStore } from '../index';

export default {
    init({ commit }) {
        DATA.then(({ translations, countries }) => {
            commit('setTranslations', translations);
            commit('setCountries', countries);
        });
    }
} as ActionTree<IState, IStore>
